/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (connections) => ({
    type: actions.CONNECTIONS_RECEIVE,
    payload: { connections },
});